var adjacent = require('./helper/adjacent');

module.exports = function succ(str) {
  return adjacent(str, -1);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/underscore.string/pred.js
 ** module id = 1093
 ** module chunks = 0
 **/